import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import common from '@/utils/common'
import Vue from 'vue'
import router from '@/router'

let setTimeout401;

const service = axios.create({
  //timeout: 5000 
})

// request拦截器
service.interceptors.request.use(
  config => {
    config.url = (Vue.prototype.BASE_API ? Vue.prototype.BASE_API : "") + config.url;
    if (common.getCookie('token')) {
      config.headers['Auth'] = common.getCookie('token')
    }
    if (common.getCookie('branchCode')) {
      config.headers['BranchCode'] = common.getCookie('branchCode')
    }
    return config
  },
  error => {
    //console.log('request error', error)
    Message({
      message: error,
      type: 'error',
    })
    return error
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    //console.log('response ',response.data)
    return response.data
  },
  error => {
    //console.log('response error', error)
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.ErrorMsg = '请求出错'
          break
        case 401:
          clearTimeout(setTimeout401);
          setTimeout401 = setTimeout(() => {
            clearTimeout(setTimeout401);
            router.push({ path: "/" });
          }, 10);
          return 
        case 403:
          error.ErrorMsg = '拒绝访问'
          break
        case 404:
          error.ErrorMsg = '请求错误,未找到该资源'
          break
        case 500:
          error.ErrorMsg = '服务器端出错'
          break
      }
    } else {
      error.ErrorMsg = '连接服务器失败'
    }  
    //Message.error({
    //  message: error.ErrorMsg
    //})
    //return Promise.reject(error.response)
    return error
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js